import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UsuarioAvatarUploadModule } from '../avatar/upload';

import { UsuarioInfobarComponent } from './usuario-infobar.component';

@NgModule({
    imports: [
        SharedModule,
        UsuarioAvatarUploadModule
    ],
    declarations: [
        UsuarioInfobarComponent
    ],
    exports: [
        UsuarioInfobarComponent
    ]
})
export class UsuarioInfobarModule { }
